var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNotice)?_c('div',{staticClass:"head-notice"},[_c('div',{staticClass:"notice c-c p",on:{"click":function($event){return _vm.notice()}}},[_c('img',{attrs:{"src":require("../assets/images/images/voice2.png"),"alt":""}}),_c('span',{staticClass:"f11 white t"},[_vm._v("1条新通知")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }